module.exports = "/_next/static/images/Curly-hair-bro-525ff13caa7e225ca22a293773857906.png";